"use client";


//===========================================
// THIS FILE IS AUTO-GENERATED FROM TEMPLATE. DO NOT EDIT IT DIRECTLY, INSTEAD EDIT THE CORRESPONDING FILE IN packages/template
//===========================================

import React from "react";
import type { StackClientApp } from "../lib/stack-app/apps/interfaces/client-app";

export const StackContext = React.createContext<null | {
  app: StackClientApp<true>,
}>(null);
